import * as React from "react";
import type { SVGProps } from "react";
const SvgShuffle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 2a1 1 0 1 0 0 2zm5 1h1a1 1 0 0 0-1-1zm-1 5a1 1 0 1 0 2 0zM3.293 19.293a1 1 0 1 0 1.414 1.414zM22 16a1 1 0 1 0-2 0zm-1 5v1a1 1 0 0 0 1-1zm-5-1a1 1 0 1 0 0 2zm-.293-5.707a1 1 0 0 0-1.414 1.414zm-11-11a1 1 0 0 0-1.414 1.414zm3.586 6.414a1 1 0 0 0 1.414-1.414zM16 4h5V2h-5zm4-1v5h2V3zM4.707 20.707l17-17-1.414-1.414-17 17zM20 16v5h2v-5zm1 4h-5v2h5zm-6.707-4.293 6 6 1.414-1.414-6-6zm-11-11 5 5 1.414-1.414-5-5z"
    />
  </svg>
);
export default SvgShuffle;
